export default __webpack_public_path__ + "static/media/Magical Strings 2018 (34 of 264).c9d65664.jpg";